





































import { container } from 'tsyringe';
import { ModelManager } from '@/prototyping/model';
import { messenger } from '@/messenger';
import { defineComponent, ref, computed } from '@vue/composition-api';
import AudioPlayer from '@/prototyping/audio-player/Container.vue';
import ViewContainer from '../components/ViewContainer.vue';

export default defineComponent({
  name: 'Home',
  components: {
    ViewContainer,
    AudioPlayer,
  },
  beforeRouteEnter(to, _from, next) {
    next((vm) => {
      // eslint-disable-next-line
      (vm as any).compactAudioPlayer = to.path !== '/';
      // unlock code, if there is some in the query like '?code=abc123'
      const { code } = to.query;
      if (typeof code === 'string') {
        const modelManager = container.resolve(ModelManager);
        const audioPlayer = modelManager.get('audio-player', 'AudioPlayerModel');
        const audioLib = modelManager.get('audio-lib', 'StoryblokAudioLibModel');
        const imageTargetTracks = modelManager.get('image-target-tracks', 'StoryblokImageTargetTracksLibModel');
        const vinylpostcards = modelManager.get('vinylpostcards', 'VinylPostcardsModel');

        if (vinylpostcards.stopAudioPlayerAndAddNewSongsFromUnlockCode(code, audioPlayer, audioLib, imageTargetTracks)) {
          messenger.unity?.core.saveSerializedAppState();
        }
      }

      // eslint-disable-next-line
      (vm as any).menuButton = to.path.startsWith('/track-info/') ? 'close' : 'menu';
    });
  },
  beforeRouteUpdate(to, _from, next) {
    // 'any' because of insufficient typescript support currently...
    // hopefully this is fixed in vue 3 (and the new router)
    // eslint-disable-next-line
    const vm = this as any;
    vm.compactAudioPlayer = to.path !== '/';
    vm.menuButton = to.path.startsWith('/track-info/') ? 'close' : 'menu';
    next();
  },
  setup(_props, ctx) {
    const menuButton = ref('menu');

    function clickMenuButton() {
      if (menuButton.value === 'menu') {
        ctx.root.$router.push('/menu');
      } else if (menuButton.value === 'close') {
        ctx.root.$router.go(-1);
      }
    }

    const unlockRoute = computed(() => {
      return process.env.VUE_APP_WEB ? '/unlock-code' : '/arimagetracking';
    });

    return {
      compactAudioPlayer: ref(ctx.root.$route.path !== '/'),
      menuButton,
      clickMenuButton,
      unlockRoute,
    };
  },
});
